import React, { useState, useEffect } from 'react';
import axios from 'axios';


export default function Bracelet() {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);



  useEffect(() => {
    const fetchImages = async () => {
      try {
        // Replace this URL with your actual API endpoint
       const response = await axios.post('https://jobeads-4d6054ae0133.herokuapp.com/images/getcat',{cat:'Bracelets'});
       // const response = await axios.post('http://localhost:5003/images/getcat',{cat:'Bracelets'});
      

        // Expecting response.data to be an array of image URLs (in correct order)
        setImages(response.data);
        console.log(response)
      } catch (error) {
        console.error("Failed to load images:", error);
        // Fallback to Unsplash images if API fails (optional)
       
      } finally {
        setLoading(false);
      }
    };

    fetchImages();
  }, []);

  return (
    <div className="min-h-screen bg-white pt-16 pb-24" style={{background:'rgb(134,111,74,.1)',paddingBottom:'50px'}}>

      {/* Title */}
      <div style={{textAlign:'center',marginTop:'30px',marginBottom:'15px'}}>
        <h1 className="text-4xl md:text-5xl font-light tracking-wider text-gray-900" style={{paddingTop:'30px'}}>
          Bracelets
        </h1>
        <p className="text-gray-500 mt-4 font-light" style={{paddingBottom:'15px',fontSize: 'clamp(1.4rem, 2.5vw, 1.4rem)'}}>
          Handcrafted with love
        </p>
      </div>

      {/* Show loading skeleton or spinner (optional but nice) */}
      {loading && (
        <div className="text-center text-gray-500">Loading beautiful bracelets...</div>
      )}

      {/* Grid - only render when images are ready */}
      <div style={{textAlign:'center'}}>
        <div className="
          grid 
          grid-cols-2 
          gap-6 
          sm:gap-8 
          lg:gap-12 
          justify-items-center
          auto-rows-fr
          [grid-auto-flow:dense]
          sm:grid-cols-3 
          lg:grid-cols-4
        ">
          {images.map((item, i) => (
            <div
              key={item?.id}
              className="flex flex-col items-center w-full max-w-[180px] sm:max-w-none relative"
              style={{position:'relative'}}
          
            >

              <div className="aspect-square w-full relative overflow-hidden rounded-13xl bg-gray-100 shadow-md" style={{maxWidth:'300px',maxHeight:'300px',minWidth:'300px',minHeight:'300px'}} >
  {loading ? (
    <div className="absolute inset-0 bg-gray-200 animate-pulse" />
  ) : (
    <img
      src={item.imagePath}
      alt={item.description}
       style={{maxWidth:'100%',maxHeight:'300px',minWidth:'300px',minHeight:'300px'}}
      loading="lazy"
    />
  )}

  {/* Diagonal SALE Ribbon – only shows if onSale is true */}
  {item.onSale && (
    <div className="absolute top-0 left-0 w-full h-50 overflow-hidden pointer-events-none"   >
      <div className="absolute left-[-34px] top-[30px] w-40 bg-red-600 text-white text-lg font-bold py-2 text-center transform rotate-[-45deg] shadow-lg" 
      style={{letterSpacing:'5px'}}
      >
        SALE
      </div>
    </div>
  )}

</div>

              <div className="mt-6 text-center relative " style={{minWidth:'300px',maxWidth:'300px',paddingBottom:'30px',width:'100%',background:'rgb(0,0,0,.1)'}}>
                <h3 className="tracking-wide text-gray-900 "
             style={{ fontSize: 'clamp(1.4rem, 2.5vw, 1.6rem)',paddingTop:'10px',fontWeight:'bold' }}
                >
                  {item.description}
                </h3>

                <p className="text-gray-800 " style={{ fontSize: 'clamp(1.1rem, 2.5vw, 1.3rem)',padding:'8px 0px' }}>
               {item.price ? `$${item.price}` : 'Contact Us'}
                </p>
                <div style={{position:'absolute',bottom:'6px',left:'10%',fontSize: 'clamp(.8rem, 2.5vw, .9rem)'}}>SKU# {item?.sku}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}